module.exports = __webpack_public_path__ + "img/collections-1.0defa487.jpg";